const ISO_DATETIME_WITHOUT_ZONE_RE = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(:\d{2}(?:\.\d{1,6})?)?$/;
const ISO_DATETIME_WITH_ZONE_RE = /(Z|[+-]\d{2}:\d{2})$/i;
const DATE_ONLY_RE = /^\d{4}-\d{2}-\d{2}$/;

export function parseServerDateTime(value) {
  if (value == null || value === '') return null;
  if (value instanceof Date) return Number.isNaN(value.getTime()) ? null : value;
  if (typeof value === 'number') {
    const d = new Date(value);
    return Number.isNaN(d.getTime()) ? null : d;
  }
  if (typeof value !== 'string') {
    const d = new Date(value);
    return Number.isNaN(d.getTime()) ? null : d;
  }

  const raw = value.trim();
  if (!raw) return null;

  if (DATE_ONLY_RE.test(raw)) {
    const [year, month, day] = raw.split('-').map(Number);
    const d = new Date(year, month - 1, day);
    return Number.isNaN(d.getTime()) ? null : d;
  }

  let normalized = raw;
  if (ISO_DATETIME_WITHOUT_ZONE_RE.test(raw) && !ISO_DATETIME_WITH_ZONE_RE.test(raw)) {
    normalized = `${raw}Z`;
  }

  const d = new Date(normalized);
  return Number.isNaN(d.getTime()) ? null : d;
}

export function formatLocalDateTime(value, options, fallback = '—') {
  const d = parseServerDateTime(value);
  return d ? d.toLocaleString([], options) : fallback;
}

export function formatLocalDate(value, options, fallback = '—') {
  const d = parseServerDateTime(value);
  return d ? d.toLocaleDateString([], options) : fallback;
}

export function formatLocalTime(value, options, fallback = '') {
  const d = parseServerDateTime(value);
  return d ? d.toLocaleTimeString([], options) : fallback;
}

export function toEpochMs(value) {
  const d = parseServerDateTime(value);
  return d ? d.getTime() : null;
}

export function localDateTimeInputToUtcIso(value) {
  if (!value) return '';
  const d = new Date(value);
  return Number.isNaN(d.getTime()) ? value : d.toISOString().slice(0, 19);
}
